export enum ResponsiveCalendarHeight {
  Auto = 'auto',
  Parent = 'parent',
}
